import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Form, Table, Button } from "react-bootstrap";
import MyAccountSidebar from "../../components/MyAccountSidebar";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { isEmpty, startCase } from "lodash";
import ReactPaginate from "react-paginate";
import Breadcrumbs from "./Breadcrumbs";
import helpers from "../../utils/helpers";
import AuthContext from "../../context/AuthContext";
import moment from "moment";
import { BiSolidRightArrow } from "react-icons/bi";
import DatePicker from "react-datepicker";

const MyAccountStatement = () => {
  let { user ,setAccountError} = useContext(AuthContext);
  const [getLogData, setLogData] = useState("");
  const [pageCount, setPageCount] = useState(0);
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [search_params, setSearchParams] = useState({
    page: 1,
    limit: 100,
    fromPeriod: previousDate.replace("/", "-"),
    toPeriod: currentDate,
    filterByDay: "",
  });
  const myStatementData = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.transactionTxnLogs,
      search_params
    );
    if (status === 200) {
      if (response_users.success) {
        setLogData(response_users.results);
        if (response_users.results.data?.length == 0) {
          setAccountError(true);
        } else {
          setAccountError(false);
        }
      }
    }
  };

  const handlePageClick = (event) => {
    setSearchParams((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
  };

  useEffect(() => {
    setPageCount(getLogData?.totalPages || []);
  }, [getLogData]);

  // useEffect(() => {
  //   myStatementData();
  // }, [search_params]);
  return (
    <div className="top-header-inner">
      <section className="py-4 main-inner-outer">
        <Container fluid>
          <Breadcrumbs />
          <Row>
            <Col lg={2}>
              <MyAccountSidebar />
            </Col>

            <Col lg={10} md={12}>
              <div className="inner-wrapper">
                {/* acccount-statement */}

                <h2 className="common-heading">Account Statement</h2>
                <Col md={12}>
                  <div className="inner-wrapper">
                    <Form className="bet_status">
                      <Row>
                        <Col xl={12} md={12}>
                          <Row>
                            <Col
                              lg={2}
                              sm={6}
                              className="mb-lg-0 mb-3 flex-grow-0 pe-3 "
                              style={{ minWidth: `260px` }}
                            >
                              <div className="bet-sec bet-period">
                                <Form.Label className="mb-0">Period</Form.Label>
                                <Form.Group className="form-group">
                                   <DatePicker
                                                                    className="small_form_control"
                                                                    selected={
                                                                      search_params.fromPeriod
                                                                        ? new Date(search_params.fromPeriod)
                                                                        : null
                                                                    }
                                                                    onChange={(date) =>
                                                                      setSearchParams({
                                                                        ...search_params,
                                                                        fromPeriod: date
                                                                          .toISOString()
                                                                          .split("T")[0],
                                                                        filterByDay: "",
                                                                      })
                                                                    }
                                                                    dateFormat="yyyy-MM-dd"
                                                                    maxDate={new Date()}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                                                                    placeholderText="Select a date"
                                                                    onFocus={(e) => e.target.blur()}
                                                                  />
                                  <Form.Control
                                    style={{
                                      marginLeft: "10px",
                                      width: "47px",
                                    }}
                                    className="small_form_control"
                                    type="text"
                                    placeholder="09:00"
                                    disabled
                                  />
                                </Form.Group>
                              </div>
                            </Col>
                            <Col
                              lg={2}
                              sm={6}
                              className="mb-lg-0 mb-3 flex-grow-0 ps-5"
                              
                            >
                              <div className="bet-sec bet-period">
                                <Form.Label className="mb-0">To</Form.Label>
                                <Form.Group className="form-group">
                                  <DatePicker
                                                                  className="small_form_control"
                                                                  selected={
                                                                    search_params.fromPeriod
                                                                      ? new Date(search_params.fromPeriod)
                                                                      : null
                                                                  }
                                                                  onChange={(date) =>
                                                                    setSearchParams({
                                                                      ...search_params,
                                                                      toPeriod: date.toISOString().split("T")[0],
                                                                      filterByDay: "",
                                                                    })
                                                                  }
                                                                  dateFormat="yyyy-MM-dd"
                                                                  minDate={
                                                                    search_params?.fromPeriod
                                                                      ? new Date(search_params?.fromPeriod)
                                                                          .toISOString()
                                                                          .split("T")[0]
                                                                      : new Date()
                                                                  }
                                                                  maxDate={new Date().toISOString().split("T")[0]}
                                                                  showMonthDropdown
                                                                  showYearDropdown
                                                                  dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                                                                  placeholderText="Select a date"
                                                                  onFocus={(e) => e.target.blur()}
                                                                />
                                  <Form.Control
                                    style={{
                                      marginLeft: "10px",
                                      width: "47px",
                                    }}
                                    className="small_form_control"
                                    type="text"
                                    placeholder="08:59"
                                    disabled
                                  />
                                </Form.Group>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <div className="history-btn mt-2">
                        <ul className="list-unstyled mb-0">
                          <li>
                            <Button
                              className={
                                search_params.filterByDay === "today"
                                  ? "me-0 theme_dark_btn"
                                  : "me-0 theme_light_btn"
                              }
                              onClick={(e) =>
                                setSearchParams({
                                  ...search_params,
                                  filterByDay: "today",
                                })
                              }
                              style={{padding:`0 10px`,lineHeight:`25px`}}
                            >
                              Just For Today
                            </Button>
                          </li>
                          <li>
                            <Button
                              className={
                                search_params.filterByDay === "yesterday"
                                  ? "me-0 theme_dark_btn"
                                  : "me-0 theme_light_btn"
                              }
                              onClick={(e) =>
                                setSearchParams({
                                  ...search_params,
                                  filterByDay: "yesterday",
                                })
                              }
                              style={{padding:`0 10px`,lineHeight:`25px`}}
                            >
                              From Yesterday
                            </Button>
                          </li>
                          <li>
                            <Button
                              className="theme_dark_btn"
                              onClick={() => myStatementData("search")}
                            >
                              Get History
                            </Button>
                          </li>
                        </ul>
                      </div>
                    </Form>
                    <div id="noReportMessage">
                      <p>
                        Banking log reserves 62 days data. Search
                        time&nbsp;period is date between 14 days, ex: 1/1~1/14,
                        1/15~28.
                      </p>
                    </div>
                    <Button className="theme_dark_btn themebtndownload">
                      Download
                    </Button>
                  </div>
                </Col>
                <section className="account-table">
                  <div className="responsive transaction-history table-color">
                    <Table>
                      <thead>
                        <tr>
                          <th scope="col">Date/Time</th>
                          <th style={{ textAlign: "right" }} scope="col">
                            Deposit
                          </th>
                          <th style={{ textAlign: "right" }} scope="col">
                            Withdraw
                          </th>
                          <th style={{ textAlign: "right" }} scope="col">
                            Balance{" "}
                          </th>
                          <th style={{ textAlign: "right" }} scope="col">
                            Remark
                          </th>
                          <th
                            scope="col"
                            style={{ textAlign: "right", width: "20%" }}
                          >
                            From/To
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {getLogData.data &&
                          getLogData.data.map((item, key) => (
                            <tr key={key}>
                              <td>
                                {helpers.tdateFormat(
                                  item?.createdAt,
                                  user?.timeZone
                                )}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {item?.transactionType == "credit" ? (
                                  <span className="classsuc">
                                    {helpers.currencyFormat(
                                      Math.abs(item?.amount)
                                    )}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </td>

                              <td style={{ textAlign: "right" }}>
                                {item?.transactionType == "debit" ? (
                                  <span className="text-danger">
                                    {"(" +
                                      helpers.currencyFormat(
                                        Math.abs(item?.amount)
                                      ) +
                                      ")"}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </td>

                              <td style={{ textAlign: "right" }}>
                                {helpers.currencyFormat(item?.newBalance)}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {item?.remark}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {startCase(item?.createdByData?.userType)}{" "}
                                <BiSolidRightArrow
                                  className="angle_unicode"
                                  color="rgb(197,208,215)"
                                  size={11}
                                />
                                {item?.userData?.username}
                              </td>
                            </tr>
                          ))}
                        {isEmpty(getLogData.data) ? (
                          <tr>
                            <td colSpan={9}>No records found</td>
                          </tr>
                        ) : null}
                      </tbody>
                    </Table>
                    {/* <div className="bottom-pagination">
                      <ReactPaginate
                        breakLabel="..."
                        nextLabel="Next"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={10}
                        pageCount={pageCount}
                        previousLabel="Prev"
                        renderOnZeroPageCount={null}
                        activeClassName="p-1"
                        activeLinkClassName="pagintion-li"
                      />
                    </div> */}
                  </div>
                </section>

                {/* acccount-statement */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default MyAccountStatement;
